import { useEffect, useRef, useState } from 'react'
import { Input, Select, Modal, Form, Button, Col, Row, Typography, Divider, Space, Radio, Steps } from 'antd'
import { observer } from 'mobx-react-lite'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { formatCurrency, validatePhoneUS, validateEmail, showMessageError } from '../../helpers/functions'
import { useStore } from '../../hooks'
import { getPage, PAGE_SIZE, ROLES, statusOrder, UK_STATES } from '../../helpers/constants'
import { debounce, size, trim } from 'lodash'
import styled from 'styled-components'
import CardItems from 'src/common/components/CardItems'
import { AMERICA_STATES } from '../../helpers/constants'

import useModal from 'src/helpers/modal/useModal'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Loading } from 'src/common'
import moment from 'moment'
const { Option } = Select

const formItemLayout = {
   labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
      md: { span: 8 }
   },
   wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
      md: { span: 16 }
   }
}

const splitUrlValues = (value: string) =>
   value
      .split(/[\n,;]/)
      .map((url) => url.trim())
      .filter(Boolean)

const urlRules = [
   () => ({
      validator(_: any, value: string) {
         if (!value) return Promise.resolve()

         const urls = splitUrlValues(value)
         const isValid = urls.every((urlValue) => {
            try {
               const url = new URL(urlValue)
               return url.protocol === 'http:' || url.protocol === 'https:'
            } catch (error) {
               return false
            }
         })

         if (isValid) {
            return Promise.resolve()
         }

         return Promise.reject('Vui lòng nhập đúng định dạng URL')
      }
   })
]

export const ModalAssignOrderWapper = styled.div`
   .expense-wrapper {
      border-left: 1px solid #e8e8e8;
   }

   label[for='CreatorOrder_shippingOption']:after {
      content: '';
   }

   @media screen and (max-width: 991px) {
      .expense-wrapper {
         border-left: 1px solid transparent;
      }
   }
`
const OrderFormModal = styled(Modal)`
   .ant-modal-content {
      height: calc(100vh - 48px);
      max-height: calc(100vh - 48px);
      display: flex;
      flex-direction: column;
   }

   .ant-modal-body {
      flex: 1 1 auto;
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
   }

   .ant-modal-footer {
      flex: 0 0 auto;
   }

   @media screen and (max-width: 575px) {
      .ant-modal-content {
         height: calc(100vh - 24px);
         max-height: calc(100vh - 24px);
      }
   }
`
const CreatorOrderScreen = observer((props: any) => {
   const { t } = useTranslation()

   const {
      item,
      visible,
      onOk,
      onCancel,
      onlyView,
      onShowProducts,
      fieldFilter,
      textSearch,
      onRemove,
      onReloadData,
      forceDraftMode,
      isDraftDetail,
      onConfirmDraftOrder
   } = props
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [isChangePassword, setIsChangePassword] = useState(false)

   const UserStore = useStore('UserStore')
   const { rows: listSeller } = UserStore.listSeller
   const [sellerId, setSellerId] = useState('')
   const [status, setStatus] = useState(parseInt(item?.status))
   const OrdersStore = useStore('OrdersStore')
   const AuthStore = useStore('AuthStore')
   const ServiceStore = useStore('ServiceStore')
   const { data_getUserInfo } = AuthStore
   const { shippingFee, listHistory } = OrdersStore
   const role: any = AuthStore.data_role
   const canEditOrderInfo = !onlyView || role === ROLES.ADMIN || isDraftDetail
   const [form] = Form.useForm()
   const { Title, Text } = Typography
   const [shippingRadio, setShippingRadio] = useState(1)
   const [isTrackingIdChanged, setIsTrackingIdChanged] = useState(false)
   const { confirm } = useModal()
   const [loading, setLoading] = useState(false)
   const submitModeRef = useRef<'create' | 'draft'>('create')

   const [listOptionState, setListOptionState] = useState(AMERICA_STATES)
   const [draftPriceData, setDraftPriceData] = useState<any>(null)
   const [availableServices, setAvailableServices] = useState<any[]>([])
   const [selectedServices, setSelectedServices] = useState<{ id: number; qty: number }[]>([])
   const [showServiceSelect, setShowServiceSelect] = useState(false)
   useEffect(() => {
      if (onlyView) {
         if (!item?.shipLabel) return setShippingRadio(2)
      }
      // OrdersStore.setProductsSelected([])
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (listSeller.length == 0 && data_getUserInfo.role !== ROLES.SELLER) {
         getListSeller()
      }
      if (item?.id) {
         getListHistory()
      }
      console.log('-----82item', item)
      if (item?.country === 'UK') {
         setListOptionState(UK_STATES)
      }
   }, [])
   useEffect(() => {
      if (item?.id) {
         getListHistory()
      }
      console.log('-----82item', item)
   }, [])

   useEffect(() => {
      if (OrdersStore.productsSelected.length === 0) {
         OrdersStore.setShippingFee(0)
         setDraftPriceData(null)
         return
      }

      if (forceDraftMode || isDraftDetail) {
         fetchDraftPrice()
      } else {
         fetchShippingFee()
      }
   }, [
      OrdersStore.productsSelected,
      OrdersStore.productsSelected.map((product: any) => product.qty).join(','),
      shippingRadio
   ])

   useEffect(() => {
      const currentSellerId =
         OrdersStore.sellerId ||
         (isDraftDetail ? item?.accountId : null) ||
         (role === ROLES.SELLER ? data_getUserInfo.id : null)
      if (currentSellerId) {
         loadAvailableServices(currentSellerId)
      } else {
         setAvailableServices([])
         setSelectedServices([])
      }
   }, [OrdersStore.sellerId])

   useEffect(() => {
      if (isDraftDetail && item?.serviceOrders && item.serviceOrders.length > 0) {
         setSelectedServices(item.serviceOrders.map((s: any) => ({ id: s.serviceId, qty: s.qty || 1 })))
      }
   }, [isDraftDetail, item])

   const fetchShippingFee = async () => {
      try {
         const sellerId = OrdersStore.sellerId || data_getUserInfo.id
         const listProduct = OrdersStore.productsSelected.map((product: any) => ({
            id: product.id,
            qty: product.qty ? product.qty : 1
         }))

         const params = {
            sellerId,
            listProduct,
            isLabel: shippingRadio === 1 ? true : false
         }
         await OrdersStore.getShippingFee(params)
      } catch (error) {
         console.error(error)
      }
   }

   const fetchDraftPrice = async () => {
      try {
         const sellerId = OrdersStore.sellerId || data_getUserInfo.id
         const listProduct = OrdersStore.productsSelected.map((product: any) => ({
            id: product.id,
            qty: product.qty ? product.qty : 1
         }))

         const params: any = {
            sellerId,
            listProduct
         }

         if (shippingRadio === 1) {
            params.shipLabel = 'label'
         }

         const result = await OrdersStore.calculateDraftPrice(params)
         if (result?.data) {
            setDraftPriceData(result.data)
            OrdersStore.setShippingFee(result.data.shippingFee || 0)
         }
      } catch (error) {
         console.error(error)
      }
   }

   const loadAvailableServices = async (userId?: number) => {
      try {
         const params: any = {}
         if (userId) {
            params.userId = userId
         }
         const result = await ServiceStore.getServiceListForUser(params)
         if (result?.rows) {
            setAvailableServices(result.rows)
         }
      } catch (error) {
         console.error(error)
      }
   }

   const getListSeller = async () => {
      try {
         // setIsLoading(true)
         const offset = getPage(0)
         const params = { offset }
         // console.log('params', params)

         await UserStore.getSeller(params)
      } catch (error) {
         // console.log(error)
      } finally {
      }
   }
   const getListHistory = async () => {
      try {
         await OrdersStore.getListHistory(item?.id)
      } catch (error) {
         // console.log(error)
      } finally {
      }
   }

   const handleRemoveProduct = (index: number) => {
      OrdersStore.removeProduct(index)
   }

   const onFinish = async (values: any) => {
      try {
         setLoading(true)
         const isDraftOrder = forceDraftMode || submitModeRef.current === 'draft'
         const {
            sellerOrderId,
            customer,
            shipLabel,
            phone,
            country,
            state,
            city,
            trackingId,
            zipCode,
            address1,
            address2,
            email,
            linkDesign,
            linkMockup,
            saigonId,
            note,
            note1,
            seller
         } = values
         let formData = null
         const listProduct = OrdersStore.productsSelected.map((product: any) => ({
            id: product.id,
            qty: product.qty ? product.qty : 1,
            linkDesign: product.linkDesign || '',
            linkMockup: product.linkMockup || ''
         }))
         if (!onlyView) {
            if (shippingRadio === 1) {
               formData = {
                  listProduct,
                  sellerOrderId,
                  linkDesign,
                  linkMockup,
                  shipLabel,
                  trackingId,
                  note,
                  note1,
                  sellerId: OrdersStore.sellerId || data_getUserInfo.id,
                  services: selectedServices.length > 0 ? selectedServices : undefined
               }
            } else {
               formData = {
                  listProduct,
                  sellerOrderId,
                  linkDesign,
                  linkMockup,
                  customer,
                  phone,
                  country,
                  state,
                  city,
                  zipCode,
                  address1,
                  address2,
                  email,
                  trackingId,
                  note,
                  sellerId: OrdersStore.sellerId || data_getUserInfo.id,
                  note1,
                  services: selectedServices.length > 0 ? selectedServices : undefined
               }
            }
         }
         const draftUpdateData = {
            listProduct,
            sellerOrderId,
            linkDesign,
            linkMockup,
            shipLabel,
            trackingId,
            note,
            note1,
            sellerId: OrdersStore.sellerId || seller || item?.accountId,
            customer,
            phone,
            country,
            state,
            city,
            zipCode,
            address1,
            address2,
            email,
            saigonId,
            services: selectedServices.length > 0 ? selectedServices : undefined
         }
         if (email) {
            if (!validateEmail(email)) {
               showMessageError('Email không đúng định dạng!')
               return
            }
         }
         const res =
            onlyView && isDraftDetail
               ? await OrdersStore.updateDraftOrder(item?.draftId || item?.id, draftUpdateData)
               : onlyView
               ? await OrdersStore.updateTrackingId(
                    item.id,
                    trackingId,
                    saigonId,
                    sellerOrderId,
                    note,
                    linkDesign,
                    linkMockup,
                    phone,
                    note1,
                    OrdersStore.productsSelected.map((product: any) => ({
                       id: product.id,
                       qty: product.qty ? product.qty : 1,
                       linkDesign: product.linkDesign || '',
                       linkMockup: product.linkMockup || '',
                       myLinkDesign: product.myLinkDesign || ''
                    }))
                 )
               : isDraftOrder
               ? await OrdersStore.createDraftOrder(formData)
               : await OrdersStore.createOrder(formData)

         if (res.code === 200) {
            OrdersStore.setProductsSelected([])
            OrdersStore.setSellerId(null)
            onOk()
         }
      } catch (error) {
         console.log(error)
      } finally {
         submitModeRef.current = 'create'
         setLoading(false)
      }
   }

   const handleConfirmOrder = (value: any) => {
      confirm({
         title: 'Bạn muốn xác nhận đơn hàng?',
         icon: <ExclamationCircleOutlined />,
         okText: 'Xác nhận',
         cancelText: 'Từ chối',
         async onCancel() {
            await OrdersStore.confirmOrder({ reject: true, orderIds: [value?.id] })
            onReloadData()
            onCancel()
         },
         async onOk() {
            await OrdersStore.confirmOrder({ reject: false, orderIds: [value?.id] })
            onReloadData()
            onCancel()
         }
      })
   }
   const handleCancelOrder = (value: any) => {
      confirm({
         title: 'Bạn xác nhận Huỷ đơn hàng?',
         icon: <ExclamationCircleOutlined />,
         okText: 'Xác nhận',
         cancelText: 'Hủy',
         async onCancel() {},
         async onOk() {
            await OrdersStore.cancelOrder(value?.id)
            onReloadData()
            onCancel()
         }
      })
   }
   const handleCompleteOrder = async (value: any) => {
      // confirm({
      //    title: 'Bạn xác nhận hoàn thành đơn hàng?',
      //    icon: <ExclamationCircleOutlined />,
      //    okText: 'Hoàn thành',
      //    cancelText: 'Hủy',
      //    async onCancel() {
      //       // await OrdersStore.cancelOrder(value?.id)
      //       // if (size(trim(textSearch)) > 0) {
      //       //    getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
      //       // } else {
      //       //    getListData(0, { ...fieldFilter })
      //       // }
      //       // onCancel()
      //    },
      //    async onOk() {
      try {
         await form.validateFields()

         // await onFinish(form.getFieldsValue())
         await OrdersStore.finishOrder(value?.id, {
            sellerOrderId: form.getFieldValue('sellerOrderId'),
            trackingId: form.getFieldValue('trackingId'),
            saigonId: form.getFieldValue('saigonId')
         })
         onReloadData()
         onCancel()
      } catch (error) {
         console.error(error)
      }
      //    }
      // })
   }

   const handleRefund = () => {
      confirm({
         title: 'Bạn muốn hoàn trả đơn hàng?',
         icon: <ExclamationCircleOutlined />,
         okText: 'Xác nhận',
         cancelText: 'Hủy',
         async onCancel() {},
         async onOk() {
            try {
               await OrdersStore.refundOrder(item.id)
               onReloadData()
               onCancel()
            } catch (error) {
               console.error(error)
            }
         }
      })
   }
   const handlePushOrder = () => {
      confirm({
         title: 'Bạn muốn đẩy đơn hàng?',
         icon: <ExclamationCircleOutlined />,
         okText: 'Xác nhận',
         cancelText: 'Hủy',
         async onCancel() {},
         async onOk() {
            try {
               let ids = []
               ids.push(item?.id)
               await OrdersStore.pushOrders(ids)
               onReloadData()
               onCancel()
            } catch (error) {
               console.error(error)
            }
         }
      })
   }
   const detectFields = (sampleFormat: any, sampleData: any) => {
      if (!sampleData) return form.resetFields()

      const formatLines = sampleFormat.trim().split('\n')
      const dataLines = sampleData.trim().split('\n')

      for (let i = 0; i < formatLines.length; i++) {
         const formatField = formatLines[i].trim()
         const dataLine = dataLines[i]?.trim()
         if (formatField === 'Name' && dataLine) {
            form.setFieldsValue({
               customer: dataLine
            })
         } else if (formatField === 'Phone' && dataLine) {
            form.setFieldsValue({
               phone: dataLine
            })
         } else if (formatField === 'Address1' && dataLine) {
            form.setFieldsValue({
               address1: dataLine
            })
         } else if (formatField === 'City,State,Country' && dataLine) {
            const [city, state, country] = dataLine.split(',').map((item: any) => item.trim())
            form.setFieldsValue({
               city: city,
               state: AMERICA_STATES.find((st) => st.label === state)?.value
            })
         } else if (formatField === 'zipCode' && dataLine) {
            form.setFieldsValue({
               zipCode: dataLine
            })
         }
      }
   }

   const sampleFormat = `
   Name
   Phone
   Address1
   City,State,Country
   zipCode
   `

   const sampleData = `
   Michael Cole
   (+1)6099702469
   215 Chinkapin Avenue
   Williamstown,New Jersey,United States
   08094
   `

   const productsPrice = () => {
      if ((forceDraftMode || isDraftDetail) && draftPriceData) {
         return parseFloat(draftPriceData.totalPrice || 0)
      }
      if (isDraftDetail && !draftPriceData) {
         return parseFloat(item?.totalPrice || 0)
      }
      const price = OrdersStore.productsSelected?.reduce(
         (acc: any, curr: any) => acc + (curr.base_cost ? curr.base_cost : 0) * (curr.qty ? curr.qty : 1),
         0
      )
      return parseFloat(price ? price : 0)
   }

   const handlingFees = () => {
      if ((forceDraftMode || isDraftDetail) && draftPriceData) {
         return parseFloat(draftPriceData.handingFee || 0)
      }
      if (isDraftDetail && !draftPriceData) {
         return parseFloat(item?.handingFee || 0)
      }
      const price = OrdersStore.productsSelected?.reduce((acc: any, curr: any) => acc + curr.handing_fee, 0)
      return parseFloat(price ? price : 0)
   }

   const serviceFees = (): number => {
      if (onlyView && !isDraftDetail) {
         return parseFloat(item?.serviceFee || 0)
      }
      return selectedServices.reduce((acc: number, sel: { id: number; qty: number }) => {
         const service = availableServices.find((s: any) => s.id === sel.id)
         return acc + (service?.price || 0) * sel.qty
      }, 0)
   }

   const totalPrice = (): number => {
      if ((forceDraftMode || isDraftDetail) && draftPriceData) {
         return parseFloat(draftPriceData.subTotalPrice || 0) + serviceFees()
      }
      if (isDraftDetail && !draftPriceData) {
         return parseFloat(item?.subTotalPrice || 0)
      }
      const total =
         shippingRadio === 1
            ? productsPrice() + handlingFees() + shippingFee + serviceFees()
            : productsPrice() + handlingFees() + shippingFee + serviceFees()
      return total
   }

   const feeByRole = (fee: string): number => {
      const isRoleFulfilment = data_getUserInfo?.role === ROLES.FULFILLMENT
      const feeName = isRoleFulfilment ? fee + 'Fullfiment' : fee

      return item ? item[feeName] : 0
   }

   const handleChangeRadioShipping = (e: any) => {
      setShippingRadio(e.target.value)
      form.resetFields(['trackingId'])
      if (isDraftDetail) {
         setIsTrackingIdChanged(true)
      }
   }
   const renderButtonFooter = () => {
      return (
         <Row className="flex gx-justify-content-center">
            {/* {(data_getUserInfo?.role == ROLES.ADMIN || data_getUserInfo?.role == ROLES.MANAGER_ORDER) &&
               (item.status === statusOrder.NEW || item.status === statusOrder.RE_NEW) && (
                  <>
                     <Divider type="vertical" />
                     <span onClick={() => handleAssign(item)} className="gx-link txtMax2LineHover">
                        {t(GLOBAL_CLIENT.assignWarehouse)}
                     </span>
                  </>
               )} */}
            {(data_getUserInfo?.role == ROLES.ADMIN ||
               data_getUserInfo?.role == ROLES.MANAGER_ORDER ||
               data_getUserInfo?.role == ROLES.FULFILLMENT) &&
               item?.status === statusOrder.ASSIGNEE && (
                  <>
                     {/* <Divider type="vertical" />
                     <span onClick={() => handleConfirmOrder(item)} className="gx-link txtMax2LineHover">
                        {'Xác nhận'}
                     </span> */}
                     <Button type="primary" key="back" onClick={() => handleConfirmOrder(item)}>
                        Xác nhận
                     </Button>
                  </>
               )}
            {(data_getUserInfo?.role == ROLES.ADMIN ||
               data_getUserInfo?.role == ROLES.MANAGER_ORDER ||
               data_getUserInfo?.role == ROLES.FULFILLMENT) &&
               item?.status === statusOrder.ACCEPTED && (
                  <>
                     <Button type="dashed" key="back" onClick={() => handleCancelOrder(item)}>
                        Huỷ đơn
                     </Button>
                  </>
               )}
            {(data_getUserInfo?.role == ROLES.ADMIN ||
               data_getUserInfo?.role == ROLES.MANAGER_ORDER ||
               data_getUserInfo?.role == ROLES.FULFILLMENT) &&
               item?.status === statusOrder.ACCEPTED && (
                  <>
                     {/* <Divider type="vertical" />
                     <span onClick={() => handleCompleteOrder(item)} className="gx-link txtMax2LineHover">
                        {'Hoàn thành đơn'}
                     </span> */}
                     <Button type="primary" key="back" onClick={() => handleCompleteOrder(item)}>
                        Hoàn thành
                     </Button>
                  </>
               )}
            {(data_getUserInfo?.role === ROLES.ADMIN ||
               data_getUserInfo?.role === ROLES.MANAGER_ORDER ||
               data_getUserInfo?.role === ROLES.SELLER) &&
               (item?.status === statusOrder.NEW || item?.status === statusOrder.RE_NEW) &&
               !item?.storeId && (
                  <Button type="primary" key="back" onClick={() => onRemove(item?.id)}>
                     {'Xóa'}
                  </Button>
               )}
            {(data_getUserInfo?.role === ROLES.ADMIN || data_getUserInfo.role === ROLES.MANAGER_ORDER) &&
               item?.status === statusOrder.FINISH && (
                  <Button type="primary" key="refund" onClick={handleRefund}>
                     {'Trả đơn hàng'}
                  </Button>
               )}

            {(data_getUserInfo?.role === ROLES.ADMIN || data_getUserInfo?.role === ROLES.MANAGER_ORDER) &&
               item?.storeId &&
               !item?.saigonId && (
                  <Button type="primary" key="PushOrder" onClick={handlePushOrder}>
                     {'Đẩy đơn hàng'}
                  </Button>
               )}
         </Row>
      )
   }
   const handleChangeSeller = (id: any) => {
      OrdersStore.setSellerId(id)
      setSelectedServices([])
   }

   const handleCancel = () => {
      OrdersStore.setProductsSelected([])
      OrdersStore.setSellerId(null)
      onCancel()
   }

   const isRoleAdmin = () => {
      return data_getUserInfo?.role == ROLES.ADMIN
   }
   const isHideButton = () => {
      if (!isRoleAdmin()) return false
      if (isRoleAdmin() && (OrdersStore.sellerId || item?.accountId)) return false

      return true
   }
   const allowUpdateTrackingId = () => {
      if (role === ROLES.ADMIN || role === ROLES.FULFILLMENT || role === ROLES.SELLER || role == ROLES.MANAGER_ORDER || data_getUserInfo?.email == 'khovp@zenith.top') return true

      return false
   }

   const getTotalProductModels = () => {
      return OrdersStore.productsSelected.length
   }

   const submitCreateOrder = () => {
      submitModeRef.current = 'create'
      form.submit()
   }

   const submitDraftOrder = () => {
      submitModeRef.current = 'draft'
      form.submit()
   }

   const confirmDraftOrder = async () => {
      await form.validateFields()
      onConfirmDraftOrder?.()
   }

   const sellerSelector = () => {
      return (
         <>
            {data_getUserInfo?.role == ROLES.ADMIN && (
               <>
                  <Title level={5}>Thông tin seller</Title>

                  <Form.Item
                     name="seller"
                     label={'Seller'}
                     initialValue={item?.accountId}
                     rules={[
                        {
                           required: true,
                           message: 'Vui lòng chọn Seller'
                        }
                     ]}
                  >
                     <Select
                        value={sellerId}
                        clearIcon
                        showSearch
                        placeholder="Chọn seller"
                        onChange={handleChangeSeller}
                        disabled={!canEditOrderInfo}
                        filterOption={(input: string, option: any) =>
                           option?.children?.toLowerCase().includes(input.toLowerCase())
                        }
                     >
                        {listSeller.map((item: any) => {
                           return (
                              <Select.Option key={item?.id} value={item?.id}>
                                 {item?.name}
                              </Select.Option>
                           )
                        })}
                     </Select>
                  </Form.Item>
               </>
            )}
         </>
      )
   }

   const trackingIdChangedCheck = (e: any) => {
      const trackingId = e.target.value
      if (isDraftDetail) {
         return setIsTrackingIdChanged(true)
      }
      if (!trackingId) return setIsTrackingIdChanged(false)
      if (item?.trackingId === trackingId) return setIsTrackingIdChanged(false)
      return setIsTrackingIdChanged(true)
   }

   const onChangeNote = (e: any) => {
      const note = e.target.value
      if (isDraftDetail) {
         return setIsTrackingIdChanged(true)
      }
      if (!isTrackingIdChanged) {
         if (!note) return setIsTrackingIdChanged(false)
         if (item?.note === note) return setIsTrackingIdChanged(false)
         return setIsTrackingIdChanged(true)
      }
   }

   const onChangeSellerOrderId = (e: any) => {
      const sellerOrderId = e.target.value
      if (isDraftDetail) {
         return setIsTrackingIdChanged(true)
      }
      if (!isTrackingIdChanged) {
         if (!sellerOrderId) return setIsTrackingIdChanged(false)
         if (item?.sellerOrderId === sellerOrderId) return setIsTrackingIdChanged(false)
         return setIsTrackingIdChanged(true)
      }
   }

   const onChangeNote1 = (e: any) => {
      const note = e.target.value
      if (isDraftDetail) {
         return setIsTrackingIdChanged(true)
      }
      if (!isTrackingIdChanged) {
         if (!note) return setIsTrackingIdChanged(false)
         if (item?.note1 === note) return setIsTrackingIdChanged(false)
         return setIsTrackingIdChanged(true)
      }
   }

   const onChangeLinkMockup = (e: any) => {
      const linkMockup = e.target.value
      if (isDraftDetail) {
         return setIsTrackingIdChanged(true)
      }
      if (!isTrackingIdChanged) {
         if (!linkMockup) return setIsTrackingIdChanged(false)
         if (item?.linkMockup === linkMockup) return setIsTrackingIdChanged(false)
         return setIsTrackingIdChanged(true)
      }
   }

   const onChangeDesign = (e: any) => {
      const linkDesign = e.target.value
      if (isDraftDetail) {
         return setIsTrackingIdChanged(true)
      }
      if (!isTrackingIdChanged) {
         if (!linkDesign) return setIsTrackingIdChanged(false)
         if (item?.linkDesign === linkDesign) return setIsTrackingIdChanged(false)
         return setIsTrackingIdChanged(true)
      }
   }

   const onChangePhone = (e: any) => {
      const phone = e.target.value
      if (isDraftDetail) {
         return setIsTrackingIdChanged(true)
      }
      if (!isTrackingIdChanged) {
         if (!phone) return setIsTrackingIdChanged(false)
         if (item?.phone === phone) return setIsTrackingIdChanged(false)
         return setIsTrackingIdChanged(true)
      }
   }

   const renderContent = () => {
      return (
         <>
            <Loading isLoading={loading}></Loading>

            <ModalAssignOrderWapper>
               <Form
                  {...formItemLayout}
                  form={form}
                  name="CreatorOrder"
                  scrollToFirstError
                  onFinish={onFinish}
                  onValuesChange={() => {
                     if (isDraftDetail) {
                        setIsTrackingIdChanged(true)
                     }
                  }}
               >
                  <Row>
                     <Col xs={24} lg={16}>
                        {sellerSelector()}
                        <Title level={5}>Sản phẩm ({getTotalProductModels()} mẫu)</Title>
                        <CardItems
                           listCard={OrdersStore.productsSelected}
                           type={onlyView && !isDraftDetail ? 'view' : 'edit'}
                           style={{
                              maxHeight: '400px',
                              overflowY: 'scroll',
                              marginBottom: '8px',
                              paddingBottom: '8px'
                           }}
                           onDelete={handleRemoveProduct}
                           imageSize={64}
                           showProductLinks
                           readOnlyProductLinks={onlyView && !isDraftDetail && !allowUpdateTrackingId()}
                           showMyLinkDesign={role === ROLES.ADMIN || data_getUserInfo?.email === 'khovp@zenith.top'}
                           onProductLinkChange={() => setIsTrackingIdChanged(true)}
                        />
                        {/* <Divider style={{ marginBottom: '20px' }}></Divider> */}
                        <div className="gx-d-flex gx-justify-content-center">
                           {(!onlyView || isDraftDetail) && (
                              <Button disabled={isHideButton()} onClick={onShowProducts}>
                                 Thêm sản phẩm
                              </Button>
                           )}
                        </div>

                        {(!onlyView || isDraftDetail) && availableServices.length > 0 && (
                           <>
                              <Title level={5}>Dịch vụ ({selectedServices.length} dịch vụ)</Title>
                              <div
                                 style={{
                                    border: '1px solid #f0f0f0',
                                    borderRadius: '4px',
                                    maxHeight: '300px',
                                    overflowY: 'auto',
                                    marginBottom: '8px'
                                 }}
                              >
                                 {selectedServices.length === 0 ? (
                                    <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>
                                       Chưa chọn dịch vụ nào
                                    </div>
                                 ) : (
                                    selectedServices.map((sel: { id: number; qty: number }) => {
                                       const service = availableServices.find((s: any) => s.id === sel.id)
                                       if (!service) return null
                                       return (
                                          <div
                                             key={service.id}
                                             style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '10px 16px',
                                                borderBottom: '1px solid #f0f0f0'
                                             }}
                                          >
                                             <span>
                                                {service.name} +{' '}
                                                <Text type="success">${formatCurrency(service.price)}</Text>
                                             </span>
                                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <Button
                                                   size="small"
                                                   onClick={() => {
                                                      if (sel.qty <= 1) {
                                                         setSelectedServices(
                                                            selectedServices.filter((s) => s.id !== sel.id)
                                                         )
                                                      } else {
                                                         setSelectedServices(
                                                            selectedServices.map((s) =>
                                                               s.id === sel.id ? { ...s, qty: s.qty - 1 } : s
                                                            )
                                                         )
                                                      }
                                                   }}
                                                >
                                                   -
                                                </Button>
                                                <span style={{ minWidth: '24px', textAlign: 'center' }}>{sel.qty}</span>
                                                <Button
                                                   size="small"
                                                   onClick={() => {
                                                      setSelectedServices(
                                                         selectedServices.map((s) =>
                                                            s.id === sel.id ? { ...s, qty: s.qty + 1 } : s
                                                         )
                                                      )
                                                   }}
                                                >
                                                   +
                                                </Button>
                                                <Button
                                                   type="link"
                                                   danger
                                                   size="small"
                                                   onClick={() =>
                                                      setSelectedServices(
                                                         selectedServices.filter((s) => s.id !== sel.id)
                                                      )
                                                   }
                                                >
                                                   Xóa
                                                </Button>
                                             </div>
                                          </div>
                                       )
                                    })
                                 )}
                              </div>
                              <div className="gx-d-flex gx-justify-content-center">
                                 <Button
                                    onClick={() => setShowServiceSelect(true)}
                                    disabled={
                                       availableServices.filter(
                                          (s: any) => !selectedServices.some((sel) => sel.id === s.id)
                                       ).length === 0
                                    }
                                 >
                                    Thêm dịch vụ
                                 </Button>
                              </div>
                              <Modal
                                 visible={showServiceSelect}
                                 title="Chọn dịch vụ"
                                 onCancel={() => setShowServiceSelect(false)}
                                 footer={null}
                                 width={500}
                              >
                                 <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    {availableServices
                                       .filter((s: any) => !selectedServices.some((sel) => sel.id === s.id))
                                       .map((service: any) => (
                                          <div
                                             key={service.id}
                                             style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '12px 16px',
                                                borderBottom: '1px solid #f0f0f0',
                                                cursor: 'pointer'
                                             }}
                                             onClick={() => {
                                                setSelectedServices([...selectedServices, { id: service.id, qty: 1 }])
                                                setShowServiceSelect(false)
                                             }}
                                          >
                                             <span>{service.name}</span>
                                             <Text type="success">${formatCurrency(service.price)}</Text>
                                          </div>
                                       ))}
                                    {availableServices.filter(
                                       (s: any) => !selectedServices.some((sel) => sel.id === s.id)
                                    ).length === 0 && (
                                       <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>
                                          Đã chọn tất cả dịch vụ
                                       </div>
                                    )}
                                 </div>
                              </Modal>
                           </>
                        )}

                        {onlyView && item?.serviceOrders && item.serviceOrders.length > 0 && (
                           <>
                              <Title level={5}>Dịch vụ ({item.serviceOrders.length} dịch vụ)</Title>
                              <div
                                 style={{
                                    border: '1px solid #f0f0f0',
                                    borderRadius: '4px',
                                    marginBottom: '16px'
                                 }}
                              >
                                 {item.serviceOrders.map((service: any, index: number) => (
                                    <div
                                       key={index}
                                       style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          padding: '10px 16px',
                                          borderBottom: '1px solid #f0f0f0'
                                       }}
                                    >
                                       <span>
                                          {service.serviceName} {service.qty > 1 ? `x${service.qty}` : ''}
                                       </span>
                                       <Text type="success">
                                          ${formatCurrency(service.servicePrice * (service.qty || 1))}
                                       </Text>
                                    </div>
                                 ))}
                              </div>
                           </>
                        )}

                        <Title level={5}>Thông tin đơn hàng</Title>
                        <Form.Item
                           name="sellerOrderId"
                           label={t(GLOBAL_CLIENT.sellerOrderId)}
                           initialValue={item?.sellerOrderId}
                        >
                           <Input maxLength={30} readOnly={!canEditOrderInfo} onChange={onChangeSellerOrderId} />
                        </Form.Item>

                        {/* <Form.Item
                           name="linkMockup"
                           label={'Link Mockup'}
                           initialValue={item?.linkMockup}
                           rules={urlRules}
                        >
                           <Input.TextArea
                              autoSize={{ minRows: 1, maxRows: 4 }}
                              maxLength={2000}
                              readOnly={!canEditOrderInfo && !allowUpdateTrackingId()}
                              onChange={onChangeLinkMockup}
                           />
                        </Form.Item>
                        <Form.Item
                           name="linkDesign"
                           label={'Link Design'}
                           initialValue={item?.linkDesign}
                           rules={urlRules}
                        >
                           <Input.TextArea
                              autoSize={{ minRows: 1, maxRows: 4 }}
                              maxLength={2000}
                              readOnly={!canEditOrderInfo && !allowUpdateTrackingId()}
                              onChange={onChangeDesign}
                           />
                        </Form.Item> */}
                        <Form.Item name="note" label={'Note'} initialValue={item?.note}>
                           <Input maxLength={500} readOnly={!canEditOrderInfo} onChange={onChangeNote} />
                        </Form.Item>
                        {(role === ROLES.ADMIN || role == ROLES.MANAGER_ORDER || data_getUserInfo?.email == 'khovp@zenith.top' ) &&  (
                           <Form.Item name="note1" label={'Note1'} initialValue={item?.note1}>
                              <Input maxLength={500} readOnly={!allowUpdateTrackingId()} onChange={onChangeNote1} />
                           </Form.Item>
                        )}

                        {!onlyView || isDraftDetail ? (
                           <Form.Item
                              labelCol={{ sm: 10, md: 12 }}
                              name="shippingOption"
                              label={
                                 <Radio.Group value={shippingRadio} onChange={handleChangeRadioShipping}>
                                    <Radio value={1}>Ship label</Radio>
                                    <Radio value={2}>Address</Radio>
                                 </Radio.Group>
                              }
                           ></Form.Item>
                        ) : null}
                        {shippingRadio == 1 ? (
                           <Form.Item
                              name="shipLabel"
                              label={t(GLOBAL_CLIENT.shippingLabel)}
                              initialValue={item?.shipLabel}
                              rules={[
                                 {
                                    required: true,
                                    message: 'Vui lòng nhập link ship lable'
                                 }
                              ]}
                           >
                              <Input style={{ width: '100%' }} maxLength={254} readOnly={!canEditOrderInfo} />
                           </Form.Item>
                        ) : (
                           <>
                              {(!onlyView || isDraftDetail) && (
                                 <Form.Item labelCol={{ xs: 24 }} wrapperCol={{ xs: 24 }} name="addressArea" label={''}>
                                    <Input.TextArea
                                       rows={6}
                                       maxLength={254}
                                       onChange={(e) => {
                                          detectFields(sampleFormat, e.target.value)
                                          if (isDraftDetail) {
                                             setIsTrackingIdChanged(true)
                                          }
                                       }}
                                       placeholder="Tiktok address form"
                                    />
                                 </Form.Item>
                              )}

                              <Form.Item
                                 name="customer"
                                 label={'Tên khách hàng'}
                                 initialValue={item?.customer}
                                 rules={[
                                    {
                                       required: true,
                                       message: 'Vui lòng nhập tên khách hàng'
                                    }
                                 ]}
                              >
                                 <Input maxLength={254} readOnly={!canEditOrderInfo} />
                              </Form.Item>
                              <Form.Item
                                 name="email"
                                 initialValue={item?.email}
                                 label={'Email'}
                                 // rules={[
                                 //    () => ({
                                 //       validator(_, value) {
                                 //          if (validateEmail(value)) {
                                 //             return Promise.resolve()
                                 //          }
                                 //          return Promise.reject('Vui lòng nhập đúng định dạng email')
                                 //       }
                                 //    })
                                 // ]}
                              >
                                 <Input style={{ width: '100%' }} maxLength={254} readOnly={!canEditOrderInfo} />
                              </Form.Item>

                              <Form.Item
                                 name="phone"
                                 initialValue={item?.phone}
                                 label={'Số điện thoại'}
                                 rules={[
                                    {
                                       required: true,
                                       message: 'Vui lòng nhập số điện thoại'
                                    }
                                    // () => ({
                                    //    validator(_, value) {
                                    //       if (validatePhoneUS(value)) {
                                    //          return Promise.resolve()
                                    //       }
                                    //       return Promise.reject('Vui lòng nhập đúng định dạng số điện thoại')
                                    //    }
                                    // })
                                 ]}
                              >
                                 <Input
                                    style={{ width: '100%' }}
                                    maxLength={254}
                                    readOnly={!canEditOrderInfo}
                                    onChange={onChangePhone}
                                 />
                              </Form.Item>
                              <Form.Item
                                 name="country"
                                 initialValue={item?.country || 'United States'}
                                 label={'Quốc gia'}
                                 rules={[
                                    {
                                       required: true,
                                       message: 'Vui lòng nhập tên quốc gia'
                                    }
                                 ]}
                              >
                                 {/* <Input style={{ width: '100%' }} maxLength={254} readOnly /> */}
                                 <Select
                                    disabled={!canEditOrderInfo}
                                    showSearch
                                    placeholder="Chọn quốc gia"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => ((option?.label as string) ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                       ((optionA?.label as string) ?? '')
                                          .toLowerCase()
                                          .localeCompare(((optionB?.label as string) ?? '').toLowerCase())
                                    }
                                    onChange={(value) => {
                                       if (isDraftDetail) {
                                          setIsTrackingIdChanged(true)
                                       }
                                       if (value === 'United States') {
                                          setListOptionState(AMERICA_STATES)
                                       }
                                       if (value === 'UK') {
                                          setListOptionState(UK_STATES)
                                       }

                                       form.setFieldsValue({ state: '' }) // Reset state when country changes
                                    }}
                                    options={[
                                       { value: 'United States', label: 'United States' },
                                       { value: 'UK', label: 'UK' }
                                    ]}
                                 />
                              </Form.Item>
                              <Form.Item
                                 name="state"
                                 label={'Tiểu bang'}
                                 initialValue={item?.state}
                                 rules={[
                                    {
                                       required: true,
                                       message: 'Vui lòng chọn tiểu bang'
                                    }
                                 ]}
                              >
                                 <Select
                                    disabled={!canEditOrderInfo}
                                    showSearch
                                    placeholder="Chọn tiểu bang"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => ((option?.label as string) ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                       ((optionA?.label as string) ?? '')
                                          .toLowerCase()
                                          .localeCompare(((optionB?.label as string) ?? '').toLowerCase())
                                    }
                                    options={listOptionState}
                                 />
                              </Form.Item>
                              <Form.Item
                                 name="address1"
                                 label={'Address 1'}
                                 initialValue={item?.address1}
                                 rules={[
                                    {
                                       required: true,
                                       message: 'Vui lòng nhập address '
                                    }
                                 ]}
                              >
                                 <Input style={{ width: '100%' }} maxLength={254} readOnly={!canEditOrderInfo} />
                              </Form.Item>
                              <Form.Item name="address2" label={'Address 2'} initialValue={item?.address2}>
                                 <Input style={{ width: '100%' }} maxLength={254} readOnly={!canEditOrderInfo} />
                              </Form.Item>
                              <Form.Item
                                 name="city"
                                 label={'Thành phố'}
                                 initialValue={item?.city}
                                 rules={[
                                    {
                                       required: true,
                                       message: 'Vui lòng nhập City'
                                    }
                                 ]}
                              >
                                 <Input style={{ width: '100%' }} maxLength={254} readOnly={!canEditOrderInfo} />
                              </Form.Item>
                              <Form.Item
                                 name="zipCode"
                                 initialValue={item?.zipCode}
                                 label={'Zip/Post code'}
                                 rules={[
                                    {
                                       required: true,
                                       message: 'Vui lòng nhập zip code'
                                    }
                                 ]}
                              >
                                 <Input style={{ width: '100%' }} maxLength={11} readOnly={!canEditOrderInfo} />
                              </Form.Item>
                           </>
                        )}
                        {allowUpdateTrackingId() && (
                           <Form.Item
                              name="trackingId"
                              label={'TrackingID'}
                              initialValue={item?.trackingId}
                              rules={[
                                 {
                                    required: shippingRadio === 1,
                                    message: 'Vui lòng nhập TrackingID'
                                 }
                              ]}
                           >
                              <Input style={{ width: '100%' }} maxLength={254} onChange={trackingIdChangedCheck} />
                           </Form.Item>
                        )}
                        {onlyView && role === ROLES.ADMIN && item?.storeId && (
                           <Form.Item name="saigonId" label={'Saigon ID'} initialValue={item?.saigonId}>
                              <Input style={{ width: '100%' }} maxLength={254} onChange={trackingIdChangedCheck} />
                           </Form.Item>
                        )}
                        {!item?.isPending && renderButtonFooter()}

                        {onlyView && item?.id && listHistory && listHistory.length > 0 && (
                           <>
                              <Title level={5} style={{ marginTop: 20 }}>
                                 Lịch sử hoạt động
                              </Title>
                              <Steps direction="vertical" size="small">
                                 {listHistory &&
                                    listHistory.map((item: any, idx: number) => {
                                       return (
                                          <Steps.Step
                                             key={idx}
                                             title={item?.description}
                                             description={moment(item?.createdAt).format('HH:mm DD/MM/YYYY')}
                                          />
                                       )
                                    })}
                              </Steps>
                           </>
                        )}
                     </Col>
                     <Col xs={24} lg={8} className="expense-wrapper">
                        <Title level={5}>Chi phí vận đơn</Title>
                        <Space direction="vertical" style={{ width: '100%' }}>
                           {role !== ROLES.FULFILLMENT && (
                              <Row justify="space-between" style={{ margin: '0 10px' }}>
                                 <span>Giá sản phẩm</span>
                                 <span>
                                    {onlyView && !isDraftDetail
                                       ? '$' + formatCurrency(item?.totalPrice)
                                       : '$' + formatCurrency(productsPrice())}
                                 </span>
                              </Row>
                           )}

                           {data_getUserInfo.role == ROLES.FULFILLMENT && (
                              <Row justify="space-between" style={{ margin: '0 10px' }}>
                                 <span>Phí đóng gói</span>
                                 <span>
                                    {onlyView && !isDraftDetail && '$' + formatCurrency(feeByRole('packingFee'))}
                                 </span>
                              </Row>
                           )}
                           <Row justify="space-between" style={{ margin: '0 10px' }}>
                              <span>Phí quản lý đơn</span>
                              <span>
                                 {onlyView && !isDraftDetail
                                    ? '$' + formatCurrency(feeByRole('handingFee'))
                                    : '$' + formatCurrency(handlingFees())}
                              </span>
                           </Row>
                           {(role !== ROLES.FULFILLMENT || (role === ROLES.FULFILLMENT && shippingRadio !== 1)) && (
                              <Row justify="space-between" style={{ margin: '0 10px' }}>
                                 <span>{shippingRadio === 1 ? 'Phí label' : 'Phí ship'}</span>
                                 <span>
                                    {onlyView && !isDraftDetail
                                       ? '$' + formatCurrency(feeByRole('shippingFee'))
                                       : '$' + formatCurrency(shippingFee)}
                                 </span>
                              </Row>
                           )}
                           {serviceFees() > 0 && (
                              <Row justify="space-between" style={{ margin: '0 10px' }}>
                                 <span>Phí dịch vụ</span>
                                 <span>{'$' + formatCurrency(serviceFees())}</span>
                              </Row>
                           )}
                           {/* {role == ROLES.FULFILLMENT && shippingRadio !== 1 && (
                           <Row justify="space-between" style={{ margin: '0 10px' }}>
                              <span>{shippingRadio === 1 ? 'Phí label' : 'Phí ship'}</span>
                              <span>
                                 {onlyView
                                    ? '$' + formatCurrency(feeByRole('shippingFee'))
                                    : '$' + formatCurrency(shippingFee)}
                              </span>
                           </Row>
                        )} */}
                           <Divider></Divider>
                           <Row justify="space-between" style={{ margin: '0 10px' }}>
                              <span>Tổng tiền</span>
                              <span>
                                 {onlyView && !isDraftDetail
                                    ? '$' + formatCurrency(feeByRole('subTotalPrice'))
                                    : '$' + formatCurrency(totalPrice())}
                              </span>
                           </Row>
                        </Space>
                     </Col>
                  </Row>
               </Form>
            </ModalAssignOrderWapper>
         </>
      )
   }

   const renderViewFooter = () => {
      if (isDraftDetail) {
         return [
            <>
               <Button key="back" onClick={onCancel}>
                  Đóng
               </Button>
               <Button key="update-draft" type="primary" disabled={loading} onClick={form.submit}>
                  Cập nhật
               </Button>
               <Button key="confirm-draft" type="primary" onClick={confirmDraftOrder}>
                  Thanh toán
               </Button>
            </>
         ]
      }

      return [
         <>
            <Button key="back" onClick={onCancel}>
               Đóng
            </Button>

            {allowUpdateTrackingId() && !item?.isPending && (
               <Button key="submit" type="primary" disabled={!isTrackingIdChanged} onClick={form.submit}>
                  Cập nhật
               </Button>
            )}
         </>
      ]
   }

   return !onlyView ? (
      <OrderFormModal
         width={'90%'}
         style={{ maxWidth: '1000px' }}
         visible={visible}
         centered
         title={forceDraftMode ? 'Tạo đơn nháp' : 'Tạo đơn'}
         okText={t(GLOBAL_CLIENT.create)}
         cancelText={t(GLOBAL_CLIENT.close)}
         onCancel={handleCancel}
         onOk={forceDraftMode ? submitDraftOrder : submitCreateOrder}
         footer={[
            <Button key="back" onClick={handleCancel}>
               {t(GLOBAL_CLIENT.close)}
            </Button>,
            data_getUserInfo.role === ROLES.SELLER && (
               <Button
                  key="draft"
                  onClick={submitDraftOrder}
                  disabled={OrdersStore.productsSelected.length === 0 || loading}
               >
                  Tạo đơn nháp
               </Button>
            ),
            !forceDraftMode && (
               <Button
                  key="submit"
                  type="primary"
                  onClick={submitCreateOrder}
                  disabled={OrdersStore.productsSelected.length === 0 || loading}
               >
                  Thanh toán
               </Button>
            )
         ]}
      >
         {renderContent()}
      </OrderFormModal>
   ) : (
      <OrderFormModal
         width={'90%'}
         style={{ maxWidth: '1000px' }}
         visible={visible}
         centered
         title={`${isDraftDetail ? 'Chi tiết đơn nháp' : 'Chi tiết đơn'} ${item?.code || ''}`}
         okText={t(GLOBAL_CLIENT.edit)}
         cancelText={t(GLOBAL_CLIENT.huy)}
         onCancel={handleCancel}
         onOk={form.submit}
         footer={renderViewFooter()}
      >
         {renderContent()}
      </OrderFormModal>
   )
})

export default CreatorOrderScreen
